import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getMergedOrderSavings = {
  name: "getMergedOrderSavings" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
